import styled from 'styled-components';
import { Calendar as BigCalendar } from 'react-big-calendar'

export const StyledBigCalendar = styled(BigCalendar)`
  padding: ${props => props.padding? props.padding : "10px 5% 20px 5%" };
  overflow: hidden;
  min-height: ${props => props.min_height? props.min_height : "692px"};
  .rbc-day-slot {
    background: ${props => props.background? props.background : "#ffffff"};
  }
`;

export const StyledHeader = styled.div`
  font-weight: 300;
  padding: 10px 0;
`;

export const StyledCustomEvent = styled.div`
  padding: 4px 6px;
  font-size: 80%;
  text-align: center;
  width: 100%;
`;

export const EventTitle = styled.div`
  padding: 10px 0;
`;

export const EventSummary = styled.div`
  font-size: 100%
`;